import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

const EngageGraphic = () => {
  const data = useStaticQuery(graphql`
    query {
      engageGraphicImage: file(relativePath: { eq: "graphics/engage-graphic.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Img
      fluid={data.engageGraphicImage.childImageSharp.fluid}
      alt="Engage Graphic"
    />
  )
}

export default EngageGraphic
